// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.outer[data-v-560997c2]{width:100%;max-height:calc(90vh - 80px - 4em);overflow:hidden;display:flex;flex-direction:column}.outer .search[data-v-560997c2]{margin-bottom:10px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
